document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("whatsappPopup");
  const openBtn = document.getElementById("openPopup");
  const closeBtn = document.getElementById("closePopup");
  const form = document.getElementById("whatsappForm");

  // Guard: bail out safely if the popup isn't on this page at all
  if (!popup || !form) return;

  const popupBox = popup.querySelector(".popup-box");
  const collaboImg = popupBox.querySelector(".collabo_image");

  function openPopup() {
    popup.style.display = "flex";
    document.body.style.overflow = "hidden"; // stop background scroll while open

    // Lazy-load the product image only when the popup actually opens
    if (collaboImg && !collaboImg.src && collaboImg.dataset.src) {
      collaboImg.src = collaboImg.dataset.src;
    }

    // Lazy-load the background image only when the popup actually opens
    if (!popupBox.style.backgroundImage) {
      popupBox.style.backgroundImage =
        "url(https://collabo.digital/wp-content/uploads/2024/09/hero-bg-home-3.png)";
      popupBox.style.backgroundSize = "cover";
      popupBox.style.backgroundPosition = "center";
    }
  }

  function closePopup() {
    popup.style.display = "none";
    document.body.style.overflow = "";
  }

  // Guard: openBtn may not exist on every page/theme section
  if (openBtn) {
    openBtn.addEventListener("click", openPopup);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  // Click outside the box closes the popup
  popup.addEventListener("click", (e) => {
    if (e.target === popup) closePopup();
  });

  // Escape key closes the popup
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.style.display === "flex") closePopup();
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const name = document.getElementById("name").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const message = document.getElementById("message").value.trim();

    if (!name || !phone) return; // required fields guard

    const whatsappNumber = "917306296724"; // <-- confirm this is the correct number
    const text =
      `Hello,%0AName: ${encodeURIComponent(name)}` +
      `%0APhone: ${encodeURIComponent(phone)}` +
      `%0AMessage: ${encodeURIComponent(message)}`;

    window.open(`https://wa.me/${whatsappNumber}?text=${text}`, "_blank", "noopener");

    form.reset();
    closePopup();
  });
});